const enum Kundengruppe {
  Endkunden = 1,
  Geschaeftskunde = 14,
  Mitarbeiter = 18
}

export default Kundengruppe;
